const AwsCourseLaunch = () => {
  return (
    <div>
      <div className="standard-paragraph">
        <h2>New Course Published: AWS Serverless Bootcamp</h2>

        <p>
          I have published a new hands-on AWS course focused on serverless architecture and practical cloud development.
        </p>

        <p>
          The course covers services such as Lambda, DynamoDB, Step Functions, API Gateway, S3, and other AWS building blocks
          used in real-world solutions.
        </p>

        <p>
          This publication is part of my broader goal of sharing practical cloud knowledge based on implementation experience,
          not only theory.
        </p>
      </div>
    </div>
  );
};

export default AwsCourseLaunch;